<template>
  <div class="coupon-enter" :class="styleType" @click="openCouponPop">
    <img v-if="styleType !== 'for-echo'" class="bg" src="./images/coupon_btn_bg.webp" alt="" />
    <div class="main">
      <!-- 其他包 -->
      <template v-if="styleType !== 'for-echo'">
        <div class="left">
          <img class="money-icon" :src="getMatchImg('coins')" alt="" />
          <span v-if="maxCoupon" class="text">{{ $t('lang.BaseModule.k016') }}</span>
        </div>
        <div class="right">
          <div v-if="maxCoupon" class="coupon-num">
            <i class="num">+{{ maxCoupon.amount }}</i>
            <span class="text">{{ maxCoupon.title }}</span>
          </div>
          <div v-else class="no-valid">{{ $t('lang.OtherModule.k009') }}</div>
          <img class="arrow" src="@/assets/packageAssets/common/arrow04.webp" alt="" />
        </div>
      </template>
      <!-- echo -->
      <template v-else>
        <div class="left">
          <img class="money-icon" src="./images/coupon-echo.webp" alt="" />
          <span class="text">{{ $t('lang.BaseModule.k016') }}</span>
        </div>
        <div class="right">
          <div v-if="maxCoupon" class="coupon-num">
            <span class="text">{{ $t('lang.CommonModule.k010') }} {{ maxCoupon.amount }}</span>
            <img :src="getMatchImg('coin')" />
          </div>
          <div v-else class="coupon-num no-valid">
            <span class="text">{{ $t('lang.OtherModule.k001') }}</span>
          </div>
          <img class="arrow" src="./images/arrow-right.webp" alt="" />
        </div>
      </template>
    </div>
  </div>
</template>

<script>
// 商城充值页面 优惠券入口
export default {
  props: {
    maxCoupon: {},
    styleType: {
      type: String,
      default: 'for-vava',
    },
  },
  data() {
    return {}
  },
  methods: {
    openCouponPop() {
      this.$emit('openCouponPop')
    },
  },
}
</script>

<style lang="less" scoped>
.coupon-enter.for-vava {
  position: relative;
  .bg {
    position: absolute;
    top: 0;
    right: 0;
    width: 100%;
    height: 100%;
    z-index: 1;
  }
  .main {
    position: relative;
    z-index: 100;
    display: flex;
    justify-content: space-between;
    width: 100%;
    height: 52px;
    padding: 0 15px;
    margin-bottom: 10px;
    font-family: 'Inter-Regular';
  }
  .left {
    display: flex;
    align-items: center;
    > span {
      color: #333;
    }
    .text {
      font-weight: 600;
      font-size: 14px;
      color: #333333;
    }
  }
  .money-icon {
    width: 42px;
    height: 42px;
    margin: 0 30px 0 0;
  }
  .right {
    display: flex;
    align-items: center;

    .coupon-num {
      display: flex;
      flex-direction: column;
      align-items: center;
      .num {
        font-weight: 600;
        font-size: 20px;
        color: #fd3d3b;
        line-height: 20px;
      }
      .text {
        font-weight: 400;
        font-size: 8px;
        color: #999999;
        line-height: 15px;
      }
    }
    .no-valid {
      padding-right: 4px;
      color: #333333;
      font-size: 14px;
    }
    .arrow {
      width: 16px;
    }
  }
}

.coupon-enter.for-echo {
  border-radius: 6px;
  background: #fff;
  padding: 0 16px 0 14px;
  .main {
    width: 100%;
    height: 68px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 10px;
    position: relative;
    z-index: 100;
  }
  .left {
    display: flex;
    align-items: center;
    > span {
      color: #333;
    }
    .text {
      font-weight: 500;
      font-size: 16px;
      color: #333333;
      font-feature-settings: 'liga' off, 'clig' off;
      font-family: 'Outfit-Bold';
    }
  }
  .money-icon {
    width: 32px;
    height: 32px;
    margin-right: 14px;
  }
  .right {
    display: flex;
    align-items: center;
    font-feature-settings: 'liga' off, 'clig' off;
    font-family: 'Outfit-Bold';

    .coupon-num {
      display: flex;
      align-items: center;
      .text {
        color: #ff7f2d;
        font-feature-settings: 'liga' off, 'clig' off;
        font-family: 'Outfit-Bold';
        font-size: 16px;
        font-style: normal;
        font-weight: 500;
        margin-right: 2px;
      }
      img {
        width: 16px;
        height: 16px;
      }
    }
    .no-valid {
      .text {
        color: #aeaeb2;
      }
    }
    .arrow {
      width: 16px;
    }
  }
}

html[lang='ar'],
html[lang='fa'],
html[lang='he'] {
  .coupon-enter {
    .bg {
      transform: rotateY(180deg);
    }
    .money-icon {
      margin: 0 0 0 30px;
    }
    .right {
      .no-valid {
        padding-left: 4px;
        padding-right: 0;
      }
      .arrow {
        transform: rotateY(180deg);
      }
    }
  }
}
</style>
